import React, { useMemo } from 'react';
import NinjaTable from 'components/tables/NinjaTable';
import getFormattedNumber from 'store/redux/utils/getFormattedNumber';
import TrafficLevelColumn from 'modules/ReportModule/components/TrafficLevelColumn';
import PathFormatter from 'modules/ReportModule/formatters/PathFormatter';
import BounceRateFormatter from 'modules/ReportModule/formatters/BounceRateFormatter';
import { useJourneyReport } from 'modules/ReportModule/context/useJourneyReport';

const FrequentPagesTable = () => {
  const { filter } = useJourneyReport();

  const columns = [
    {
      key: 'path',
      name: 'Path ',
      renderCell: PathFormatter,
      resizable: true,
    },
    {
      key: 'visitors',
      name: 'Visitors ',
      renderCell: ({ row }) => <span className='text-sm font-medium'>{row?.visitors}</span>,
    },
    {
      key: 'page_views',
      name: 'Page Views',
      renderCell: ({ row }) => <span className='text-sm font-medium'>{row?.page_views}</span>,
    },
    {
      key: 'bounce_rate',
      name: 'Bounce Rate',
      renderCell: BounceRateFormatter,
    },

    {
      key: 'page_views_per_session',
      name: 'Page Views per Session',
      renderCell: ({ row }) => (
        <span className='text-sm font-medium'>
          {getFormattedNumber(row?.page_views_per_session)}
        </span>
      ),
    },
    {
      key: 'entry_rate',
      name: 'Entry Rate',
      renderCell: ({ row }) => (
        <span className='text-sm font-medium'>{getFormattedNumber(row?.entry_rate)}%</span>
      ),
    },
  ];

  const allLevelColumns = useMemo(() => {
    return Object.keys(TrafficLevelColumn).map((key) => ({
      ...TrafficLevelColumn[key],
      resizable: true,
      minWidth: 200,
      sortable: true,
    }));
  }, []);

  return (
    <NinjaTable
      cardProps={{ disable: true }}
      dataProvider='frequentPages'
      date_key='frequentPages'
      columns={[...columns]}
      disableFooter
      queryParams={{
        filters: {
          ...filter,
        },
      }}
    />
  );
};

export default FrequentPagesTable;
